import { render, staticRenderFns } from "./newTicket.vue?vue&type=template&id=06fc36c0&scoped=true"
import script from "./newTicket.vue?vue&type=script&lang=js"
export * from "./newTicket.vue?vue&type=script&lang=js"
import style0 from "./newTicket.vue?vue&type=style&index=0&id=06fc36c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc36c0",
  null
  
)

export default component.exports